export const SMS_SERVICE_PATH = '/api/dashboard/sms-service'

export const TWILIO_INTEGRATION_PATH = `${SMS_SERVICE_PATH}/user-twilio-account`
export const TWILIO_PHONE_NUMBERS_PATH = `${SMS_SERVICE_PATH}/phone-numbers/list`
export const TWILIO_MESSAGE_SERVICES_PATH = `${SMS_SERVICE_PATH}/message-services/list`
